<template>
  <div class="shopping-cart-interior">
  <div class="container app-container h-100">
        <ShoppingCart/>
  </div>
  </div>
</template>

<script>
import ShoppingCart from './components/ShoppingCart.vue'

export default {
  name: 'App',
  components: {
    ShoppingCart
  },
  beforeCreate() {
    this.$store.commit('initializeStore');
  }
}
</script>

<style type="text/scss" lang="scss">
    .shopping-cart-interior {
        @import "../node_modules/bootstrap/scss/bootstrap";
    }
</style>

<style scoped>
h2 {
  font-weight: bold;
  margin-bottom: 0;
}
.btn-light{
  font-size: 1.25rem;
  background-color: transparent;
  border: none;
}
.overlay-button{
  position: absolute;
}
.overlay-button button{
  margin-left: 1.6rem;
}
.app-container{
  /* height: 63%; */
}
.shopping-cart-interior {
  height: 100%;
  max-height: 100%;
  font-family: 'Source Sans Pro';
}
[data-theme="dark"] .app-container {
  background-color: #242424;
  color: white;
}
</style>
<style>
.shopping-header{
  background-color: #dfdfdf;
}
</style>
